/**
 * @generated SignedSource<<1ecfd65acad56026e4b21d2fc3f79844>>
 * @relayHash ad495f4d503db96ba0c38eb7772dc8ee
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ad495f4d503db96ba0c38eb7772dc8ee

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CodeTagChoice = "exam" | "part" | "question";
export type HtmlTag = "HTML";
export type ChangeCodeTagDetailsInput = {
  answer?: CodeTagInput | null;
  bodyItemId: string;
  choices?: CodeTagChoice | null;
  clientMutationId?: string | null;
  prompt?: HtmlInput | null;
  updateAnswer?: boolean | null;
  updateChoices?: boolean | null;
  updatePrompt?: boolean | null;
};
export type CodeTagInput = {
  lineNumber: number;
  selectedFile?: string | null;
};
export type HtmlInput = {
  type: HtmlTag;
  value: string;
};
export type CodeTagChangeMutation$variables = {
  input: ChangeCodeTagDetailsInput;
};
export type CodeTagChangeMutation$data = {
  readonly changeCodeTagDetails: {
    readonly bodyItem: {
      readonly answer: any | null;
      readonly id: string;
      readonly info: any;
    };
  } | null;
};
export type CodeTagChangeMutation = {
  response: CodeTagChangeMutation$data;
  variables: CodeTagChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChangeCodeTagDetailsPayload",
    "kind": "LinkedField",
    "name": "changeCodeTagDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BodyItem",
        "kind": "LinkedField",
        "name": "bodyItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "info",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answer",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CodeTagChangeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CodeTagChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ad495f4d503db96ba0c38eb7772dc8ee",
    "metadata": {},
    "name": "CodeTagChangeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "22f94e042e948aabf817deb3fd606eb0";

export default node;
